<template>
  <div>
    <div class="mx-auto mt-3 pb-2">
      <div class="text-center mx-auto chat-action">
        <v-row justify="center" align="center" class="mr-9">
          <v-col cols="12">
            <v-card
              flat
              prominent
              tile
              dense
              color="transparent"
              v-show="!isMinimize"
            >
              <v-row align="center" justify="center">
                <v-col class="shrink">
                  <div class="d-flex">
                    <v-btn
                      class="mx-2 "
                      dark
                      fab
                      small
                      :outlined="micOn"
                      color="primary"
                      @click="mic"
                    >
                      <v-icon dark> {{ microphone.icon }} </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2 "
                      fab
                      small
                      dark
                      :outlined="!isHold"
                      color="primary"
                      @click="holdClicked"
                    >
                      <v-icon dark> mdi-pause </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2 "
                      fab
                      small
                      dark
                      outlined
                      :color="variables.primary"
                      @click="transferSession"
                    >
                      <v-icon dark> mdi-swap-horizontal </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      dark
                      outlined
                      :color="variables.primary"
                      @click="endCallClicked"
                    >
                      <v-icon dark> mdi-phone-hangup </v-icon>
                    </v-btn>
                  </div>
                  <audio ref="remoteAudioView" autoplay />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import variables from '@/styles/variables.scss'

import _ from 'lodash'
import apiSetting from '@/apis/setting'
import Chatbotix from '@/assets/chatbotix.png'
import { mapGetters, mapActions } from 'vuex'
import JsSIP from 'jssip'
import { bus } from '../../../main'
export default {
  name: 'VoiceClient',
  data() {
    return {
      variables: variables,

      ua: Object,
      callSipAdder: '3804',
      msg: '',
      micOn: true,
      incomingSession: Object,
      outgoingSession: Object,
      localStream: Object,
      constraints: {
        audio: true
      },
      microphone: {
        color: variables.primary,
        icon: 'mdi-microphone'
      },
      isHold: false,
      holdBtnColor: variables.primary,
      currentSession: null,
      time: '00:00:00',
      statusText: '',
      isShowStatus: false,
      ChatbotixImg: Chatbotix,
      isMinimize: false,
      media: null,
      isShowRing: null,
      isShowSecondRing: null,
      refreshInterval: null
    }
  },
  mounted() {
    this.init()
    this.micOn = true
    this.isHold = false
  },
  created() {
    bus.$on('startCall', val => {
      this.call(val)
      this.isMinimize = false
      clearInterval(this.refreshInterval)
    })
    bus.$on('terminateCall', val => {
      // clearInterval(this.refreshInterval)
      this.endCall(val)
    })
    bus.$on('dropCallByDoLogout', val => {
      this.endCall(val)
    })
    bus.$on('lostConnection', val => {})

    window.addEventListener('unload', this.leaving)
  },
  beforeDestroy() {
    bus.$off('startCall')
    bus.$off('terminateCall')
    bus.$off('dropCallByDoLogout')
    bus.$off('lostConnection')
  },
  watch: {
    $route(to, from) {
      if (to.name == 'Live agent') {
        this.isMinimize = false
      } else {
        this.isMinimize = true
      }
    }
  },
  computed: {
    ...mapGetters('agent', ['activeLiveCallSessionId'])
  },
  methods: {
    ...mapActions('agent', ['setWebRtcSession']),
    minimizeClient() {
      this.isMinimize = !this.isMinimize
      clearInterval(this.refreshInterval)
    },

    leaving(e) {
      this.setWebRtcSession('Inactive')
      this.endCall('hanged up')
    },

    async init() {
      const settings = await apiSetting.getSetting()
      const isEnableWebRtc = _.find(settings.data, { key: 'webrtc_enable' })

      if (
        typeof isEnableWebRtc !== 'undefined' &&
        isEnableWebRtc.value == 'true'
      ) {
        const webRtcUrl = _.find(settings.data, { key: 'webrtc_url' }).value
        const webRtcUser = _.find(settings.data, { key: 'webrtc_user' }).value
        const webRtcPassword = _.find(settings.data, { key: 'webrtc_password' })
          .value

        const socket = new JsSIP.WebSocketInterface(
          `wss://${webRtcUrl}:8089/ws`
        )
        const configuration = {
          sockets: [socket],
          uri: `sip:${webRtcUser}@${webRtcUrl}`,
          contact_uri: `sip:${webRtcUser}@${webRtcUrl}`,
          authorization_user: webRtcUser,
          password: webRtcPassword,
          display_name: 'TVO Test',
          session_timers: false,
          register_expires: 30
        }
        this.ua = new JsSIP.UA(configuration)
        this.ua.on('registered', function(data) {
          // console.info(
          //   'registered: ',
          //   data.response.status_code,
          //   ',',
          //   data.response.reason_phrase
          // )
        })
        this.register()
      }
    },
    initMedia() {
      navigator.mediaDevices
        .getUserMedia(this.constraints)
        .then(media => {
          this.media = media
          // console.log(media)
        })
        .catch(function(err) {
          // console.log(err)
          // console.error(err.name + ': ' + err.message)
        })
    },

    setRemoteStream(event) {
      //   const video = this.$refs.remoteVideoStream
      const audio = this.$refs.remoteAudioView
      //   video.srcObject = event.stream
      //   video.onloadedmetadata = function(e) {
      //     video.play()
      //     console.log(e)
      //   }

      if (event) {
        audio.srcObject = event.stream

        audio.onloadstart = e => {
          audio.play()
        }
        audio.onerror = () => {
          alert('audio Error...')
        }
      }
    },
    register() {
      // this.initMedia()
      this.ua.registrator().setExtraHeaders(['X-Foo: bar'])
      const sip = this
      this.ua.on('newRTCSession', function(data) {
        // console.log(data)
        // console.info('outgoingSession')
        sip.outgoingSession = data.session
        sip.outgoingSession.on('connecting', function(data) {})
      })
      this.ua.on('newMessage', function(data) {
        // console.log(data)
        if (data.originator === 'local') {
          // console.info('onNewMessage , OutgoingRequest - ', data.request)
        } else {
          // console.info('onNewMessage , IncomingRequest - ', data.request)
        }
      })
      this.ua.on('sipEvent', function(data) {
        // console.log(data)
      })
      this.ua.on('hold', function(data) {
        // console.log('hold ==== ', data)
      })
      this.ua.start()
    },
    hold() {
      this.outgoingSession.hold()
    },
    unhold() {
      this.outgoingSession.unhold()
    },
    mic() {
      if (this.micOn) {
        this.microphone.icon = 'mdi-microphone-off'
        this.micOn = false
        this.muted()
      } else {
        this.microphone.icon = 'mdi-microphone'
        this.micOn = true
        this.unmuted()
      }
    },
    call(val) {
      bus.$emit('startTimer')
      const that = this
      // Register callbacks to desired call events
      const eventHandlers = {
        progress: function(e) {
          // console.log('call is in progress: ' + e)
          // console.log(`Calling to bridge_number : ${number} in progress `)
        },
        failed: function(e) {
          // console.log('failed', e)
          bus.$emit('isHangUp', 'user')
          bus.$emit('isCallEnded', false)
        },
        ended: function(e) {
          // console.log('ended', e)

          if (e.originator == 'remote') {
            bus.$emit('isHangUp', 'user')
          }
          bus.$emit('isCallEnded', false)
        },
        confirmed: function(e) {},
        peerconnection: function(event) {
          // console.log(event)
          event.peerconnection.onaddstream = function(ev) {
            // console.info('onaddstream from remote - ', ev)
            that.setRemoteStream(ev)
          }
        }
      }

      const record_file_name = `livecall_${val.bridge_number}_${val.transfer_count}`

      const options = {
        eventHandlers: eventHandlers,
        extraHeaders: [
          `bridge_number: ${val.bridge_number}`,
          `recording_url_filename: ${record_file_name}`
        ],
        mediaConstraints: { audio: true, video: false }
      }
      const session = this.ua.call(this.callSipAdder, options)

      this.currentSession = session
      this.setWebRtcSession(val.bridge_number)
    },
    endCall(val) {
      const options = {
        extraHeaders: [`next_action: ${val}`],
        status_code: 601,
        reason_phrase: 'agent_leave'
      }
      this.ua.terminateSessions(options)
      //   bus.$emit('callStatus', 'CALL ENDED - AGENT HANGUP')
      this.isHold = false
      this.micOn = true
      this.isMinimize = false
      bus.$emit('isCallEnded', false)
    },
    endCallClicked() {
      bus.$emit('isHangUp', 'agent')
    },
    muted() {
      this.outgoingSession.mute({ audio: true, video: true })
    },
    unmuted() {
      this.outgoingSession.unmute({ audio: true, video: true })
    },
    holdClicked() {
      if (!this.isHold) {
        this.hold()
        this.isHold = true
      } else {
        this.unhold()
        this.isHold = false
      }
    },
    transferSession() {
      bus.$emit('isTransfer')
    }
  }
}
</script>

<style lang="scss" scoped></style>
